export const setToken = ({ commit }, value) => {
  commit('SETTOKEN', value)
}
export const setUserId = ({ commit }, value) => {
  commit('SETUSERID', value)
}
export const setUserinfo = ({ commit }, value) => {
  commit('SETUSERINFO', value)
}
export const removeData = ({ commit }) => {
  commit('REMOVEDATA')
}
export const signUpList = ({ commit }, value) => {
  commit('SIGNUPLIST', value)
}
export const clearSignUpList = ({ commit }) => {
  commit('CLEARSIGNUPLIST')
}



// WEBPACK FOOTER //
// ./src/store/actions.js